<template>
  <div>
    <div class="terms-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">{{ translations.FAQ.faq }}</h2>
            <div>
              <p>
               {{ translations.FAQ.text1 }}
              </p>
              <p><strong>{{ translations.FAQ.q1 }}</strong></p>
              <p><strong>{{ translations.complaints.businessCustomers }}</strong></p>
              <p>
                {{ translations.FAQ.text2 }}
              </p>
              <p><strong>{{ translations.complaints.privateBuyers }}</strong></p>
              <p>
                {{ translations.FAQ.text3 }}
              </p>
              <p><strong></strong></p>
               <p><strong>{{ translations.complaints.businessCustomers }}</strong></p>
              <p>
                {{ translations.FAQ.text4 }}
              </p>
              <p><strong>{{ translations.complaints.privateBuyers }}</strong></p>
              <p>
                {{ translations.FAQ.text5 }}
              </p>
              <p><strong>{{ translations.FAQ.q3 }}</strong></p>
              <p><strong>{{ translations.complaints.businessCustomers }}</strong></p>
              <p>{{ translations.FAQ.text6 }}</p>
              <ul>
                <li>{{ translations.FAQ.eurosanFreeDelivery }}</li>
                <li>{{ translations.FAQ.postDelivery }}</li>
                <li>
                  {{ translations.FAQ.text7 }}
                </li>
              </ul>
              <p><strong>{{ translations.complaints.privateBuyers }}</strong></p>
              <p>
                {{ translations.FAQ.text8 }}
              </p>
              <p>
                {{ translations.FAQ.text9 }}
              </p>
              <p><strong>{{ translations.FAQ.q4 }}</strong></p>
              <p>
                {{ translations.FAQ.text10 }}
              </p>
              <p>
                <strong
                  >{{ translations.FAQ.q5 }}</strong
                >
              </p>
              <p><strong>{{ translations.FAQ.businessCustomers }}</strong></p>
              <p>
                {{ translations.FAQ.text11 }}
              </p>
              <p>
                {{ translations.FAQ.text12 }} <strong>{{ translations.FAQ.text13 }} </strong
                ><a href="mailto:webshop@eurosan.ba"><strong>webshop@eurosan.ba</strong></a
                ><strong>.</strong>
              </p>
              <p><strong>{{ translations.FAQ.privateBuyers }}</strong></p>
              <p>
                {{ translations.FAQ.text14 }}
                <strong>080 080 080</strong> {{ translations.FAQ.text15 }}
              </p>
              <p><strong>{{ translations.FAQ.q6 }}</strong></p>
              <p>
                {{ translations.FAQ.text16 }}
              </p>
              <p><strong>{{ translations.FAQ.q7 }}</strong></p>
              <p>
                {{ translations.FAQ.text17 }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { translations } from '@/mixins';

export default {
  name: 'FAQ',
  mixins: [translations],
};
</script>
